export default __webpack_public_path__ + "img/bJuIiuHv.63787cf0.svg";